let URL = APP_URL;

$(function () {
    Dashmix.helpers(
        ['select2','summernote']
    );
});

delMat = function (e) {
    var data = e 
    window
        .axios
        .post(URL+'/admin/del-material',{
            id:data
        })
        .then(function (response) {
            //handle succes
            $( "#mat"+e ).remove();
            $( "#del"+e ).remove();
            alert("Material excluido com Sucesso");
        })
        .catch(function (response) {
            //handle error
            alert("Ocorreu um erro ao deletar os dados."+response);
        });
}

$(document).ready(function(){
    $('#course_selected').change(function(){
        let value = $(this).val();              
        $('#sel_course').empty();//limpando os options existentes
        $.ajax({               
            url: URL+'/admin/getModules/'+value,
            type: "GET",
            dataType: 'json',
            success: function(response){
                $('#sel_course').append('<option></option>');//para funcionar o placeholder                            
                $.each (response, function (indice) {
                    $('#sel_course').append('<option class"course_module" value="' + response[indice].id + '">' +
                        response[indice].title + '</option>');
                    });
            },
            error: function() {
                alert("Ocorreu um erro ao carregar os dados."+value);
            }
        });

    });
    
});
